import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class I18nService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getTranslations(
        language: string,
        key: string,
        loadAll: boolean,
        filter?: string,
        pageSize: number = 100,
        pageIndex: number = 0,
    ): Observable<I18nTranslations> {
        let params = new HttpParams()
            .set('key', key)
            .set('loadAll', loadAll)
            .set('pagination', `${pageSize},${pageIndex}`);
        if (filter && filter.trim().length > 0) {
            params = params.set('filter', filter.trim());
        }
        return this.http.get<I18nTranslations>(`${environment.apiUrl}/i18n/${language}`, { params })
    }

    postTranslation(language: string, key: string, id: string, value: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}/i18n/${language}/translation?key=${key}`, {id: id, value: value})
    }

    deleteTranslation(language: string, key: string, stringId: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/i18n/${language}/translation/${encodeURIComponent(stringId)}?key=${key}`)
    }

    deleteString(language: string, key: string, stringId: string): Observable<any> {
        return this.http.delete(`${environment.apiUrl}/i18n/${language}/string/${encodeURIComponent(stringId)}?key=${key}`)
    }
}

export type I18nTranslations = {
    translations: I18nTranslation[]
    total: number
}

export type I18nTranslation = {
    id: string
    defaultValue: string
    extraDefaultValue?: string
    value: string
    aiReviewed: boolean
    humanReviewed: boolean

    // Not in the API, but used in the frontend
    originalValue?: string
    error?: string
}
